import {
    useSubCategoriesOverviewV2,
    useUserIndustriesOverviewV2,
} from 'utils/hooks/useUserIndustries';
import { formatGrowth, formatVolume } from 'utils/helpers';
import { DATA_SOURCES } from '@/config/constants';
import { createSourceBreadCrumbs } from './createSourceBreadCrumbs';

const popularityMetrics = [
    {
        key: 'popularity_index_avg_12_month',
        label: 'Popularity',
        formatter: formatVolume,
    },
    { key: 'YoY', label: 'YoY', formatter: formatGrowth },
];

const {
    BreadCrumbs: PopularityBreadCrumbs,
    IndustriesOnlyBreadCrumbs: PopularityIndustriesOnlyBreadCrumbs,
} = createSourceBreadCrumbs({
    dataSource: DATA_SOURCES.POPULARITY,
    useSubcategories: useSubCategoriesOverviewV2,
    useIndustries: useUserIndustriesOverviewV2,
    metrics: popularityMetrics,
    showIndustryMetrics: false,
});

export { PopularityIndustriesOnlyBreadCrumbs };

export default PopularityBreadCrumbs;
